import React from "react";
import { boostLookbackSelectionUrl } from '../../consts';

const renderUpgradeLink = (currentProductTier) => {
  if (!currentProductTier.includes("VIP")) {
    return  (
      <>
        <a
          className="text-boost-primary-purple hover:text-purple-600"
          href={`/dashboard${boostLookbackSelectionUrl}`}
        >
          <u>Upgrade</u>
        </a>
        {" "} for up to 2 years of instant reporting and history .
      </>
    );
  }
  return ( <></> )
};

const BoostDontSeePayment = ({
  handleDontSeePayment,
  currentProductTier,
  lookbackPeriod,
  close: closeWithOpenFinicity,
}) => {
  return (
    <>
      <div className="flex flex-row mx-auto bg-gray-200 border-gray-500 border-b pl-4 ">
        <button type="button" className="mt-2 mr-2" onClick={handleDontSeePayment}>
          <i className="text-2xl fa-solid fa-arrow-left"/>
        </button>
        <h3 className="mt-2 text-xl">{"Don't See your payment?"}</h3>
      </div>
      <div style={{ minHeight: "100%" }} className="flex py-2 px-4 flex-col bg-white">
        <p className="py-1 ">
            It can take a while for transactions to show up. You can log back in and match that payment once it appears in your TomoBoost Account.
        </p>
        <p className="text py-1 ">
          Your {currentProductTier} membership allows {lookbackPeriod} of bills to be shown.{" "}
          { renderUpgradeLink(currentProductTier) }
        </p>
        <p className="text py-1 ">
            We will not show any deposits, as these are not recurring bills.
        </p>
        <p className="text py-1 ">
          If you made a payment from a different account or financial institution that has not been linked to your TomoBoost account yet, you can add it {" "}
          <button
            type="button"
            onClick={() => { closeWithOpenFinicity(null, null, true); }}
            className="text-boost-primary-purple hover:text-purple-600"
          >
            <u>here.</u>
          </button>
        </p>
      </div>
    </>
  );
};

export default BoostDontSeePayment;